import { assetSrc } from 'utils';
import { capitalize } from './capitalize';
import { convertWeight } from './convertWeight';
import { daysElapsed } from './daysElapsed';
import { humanize } from './humanize';
import { kebabCase } from './kebabCase';
import { padStart } from './padStart';
import { snakeCase } from './snakeCase';
import { toMinutes } from './toMinutes';

export const Filters = angular
  .module('App.filters', [])
  .filter('assetSrc', () => assetSrc)
  .filter('capitalize', capitalize)
  .filter('convertWeight', convertWeight)
  .filter('daysElapsed', daysElapsed)
  .filter('humanize', humanize)
  .filter('kebabCase', kebabCase)
  .filter('padStart', padStart)
  .filter('snakeCase', snakeCase)
  .filter('toMinutes', toMinutes).name;



// WEBPACK FOOTER //
// ./src/filters/index.js